define("media/utils/formatters/create-formatted-industry-hashtags", ["exports", "@ember/object", "shared/utils/string-formatters/snake-to-camel", "later/utils/object-methods", "lodash"], function (_exports, _object, _snakeToCamel, _objectMethods, _lodash) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  /**
   * Raw hashtag item from the API response
   * @typedef {{tag: String, numberOfPosts: Number}} RawHashtagItem
   */

  /**
   * Formatted hashtag item, including rank compared to other hashtags by number of posts
   * @typedef {{startTime: Number, endTime: Number, numberOfPosts: Number, totalPosts: Number, percentagePosts: Number, rank: Number, type: String }} FormattedHashtagItem
   */

  /**
   * Transform a raw hashtag item into a formatted one
   *
   * @property formattedHashtagItem
   * @param {RawHashtagItem} rawHashtagItem raw hashtag item
   * @param {Number} totalPosts total later posts with this hashtag
   * @param {Number} rank rank compared to other hashtags, based on number of posts
   * @param {String} [type='industry'] type of hashtag item
   *
   * @return {FormattedHashtagItem} formatted hashtag item
   */
  function formattedHashtagItem(rawHashtagItem, totalPosts, rank) {
    let type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'industry';
    return _object.default.create({
      tag: rawHashtagItem.tag,
      hashtag: rawHashtagItem.tag,
      numberOfPosts: rawHashtagItem.numberOfPosts,
      percentagePosts: rawHashtagItem.numberOfPosts / totalPosts * 100,
      rank,
      type
    });
  }
  /**
   * List of raw hashtags
   * @typedef {{startTime: Number, endTime: Number, hashtags: Array.<RawHashtagItem>, totalPosts: Number}} RawIndustryHashtags
   */

  /**
   * List of hashtags, and total posts for Industry between given time period bounds
   * @typedef {{startTime: Number, endTime: Number, hashtags: Array.<FormattedHashtagItem>, totalPosts: Number}} FormattedIndustryHashtags
   */

  /**
   * Format a raw industry hashtags response, by formatting each hashtag item
   *
   * @property formattedIndustryHashtags
   * @param {RawIndustryHashtags} rawIndustryHashtags raw industry hashtags dataset
   *
   * @return {FormattedIndustryHashtags} formatted industry hashtags dataset
   */


  function formattedIndustryHashtags(rawIndustryHashtags) {
    const orderedHashtags = (0, _lodash.orderBy)(rawIndustryHashtags.hashtags, ['numberOfPosts'], ['desc']);
    const formattedHashtags = orderedHashtags.map((rawHashtag, index) => formattedHashtagItem(rawHashtag, rawIndustryHashtags.totalPosts, index + 1));
    return _object.default.create({
      startTime: rawIndustryHashtags.startTime,
      endTime: rawIndustryHashtags.endTime,
      hashtags: formattedHashtags,
      totalPosts: rawIndustryHashtags.totalPosts
    });
  }
  /**
   * Create a standardized formatted industry hashtags dataset
   *
   * @property createFormattedIndustryHashtags
   * @param {RawIndustryHashtags} rawIndustryHashtags raw industry hashtags dataset
   *
   * @return {FormattedIndustryHashtags} formatted industry hashtags dataset
   */


  function createFormattedIndustryHashtags(rawIndustryHashtags) {
    const sanitizedIndustryHashtags = _sanitizeRawIndustryHashtags(rawIndustryHashtags);

    return formattedIndustryHashtags(sanitizedIndustryHashtags);
  }
  /**
   * Formats the raw industry hashtags data to use camel case
   * instead of snake case for all key names
   * by calling @objectSnakeToCamel, and converting all unix
   * dates to Number values
   *
   * @method _sanitizeRawIndustryHashtags
   * @param {RawIndustryHashtags} rawIndustryHashtags raw industry hashtags dataset
   * @protected
   *
   * @return {RawIndustryHashtags} Sanitized industry hashtags dataset
   */


  const _sanitizeRawIndustryHashtags = rawIndustryHashtags => {
    // Note: this only applies when running mirage
    if (rawIndustryHashtags.id) {
      delete rawIndustryHashtags.id;
    }

    return (0, _objectMethods.objectMap)(rawIndustryHashtags, _ref => {
      let [keyName, value] = _ref;

      switch (keyName) {
        case 'hashtags':
          return [(0, _snakeToCamel.default)(keyName), value.map(tagObject => (0, _objectMethods.objectSnakeToCamel)(tagObject))];

        case 'start_time':
          return [(0, _snakeToCamel.default)(keyName), Number(value)];

        case 'end_time':
          return [(0, _snakeToCamel.default)(keyName), Number(value)];

        default:
          return [(0, _snakeToCamel.default)(keyName), value];
      }
    });
  };

  var _default = createFormattedIndustryHashtags;
  _exports.default = _default;
});